/* eslint-disable @typescript-eslint/ban-ts-comment */

import { Check, Delete, Warning } from '@mui/icons-material'
import { CircularProgress, Divider, Typography } from '@mui/material'
import { Box, Button, IconButton } from 'components'
import { useFiles } from 'contexts'
import { Fragment } from 'react'

const Attachment = ({ file }: any) => {
  const { deleteFile } = useFiles()
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 50
      }}
    >
      <div style={{ flex: 1, maxWidth: 500 }}>
        <Typography
          variant="body1"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {file?.name}
        </Typography>
        <Typography variant="caption">{file?.readableSize}</Typography>
      </div>
      <div
        style={{
          display: 'flex',

          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {file.progress !== 100 && (
          <CircularProgress
            variant="determinate"
            size={20}
            value={file.progress}
          />
        )}
        {file.progress === 100 && !file.error && <Check color="success" />}

        {file.error && <Warning color="error" />}
        <IconButton
          size="small"
          disabled={file.progress < 100 && !file.uploaded}
          onClick={(event: any) => {
            event?.stopPropagation?.()
            deleteFile(file.id)
          }}
        >
          <Delete
            color={file.progress < 100 && !file.uploaded ? 'disabled' : 'error'}
            fontSize="small"
          />
        </IconButton>
      </div>
    </div>
  )
}

type Props = {
  multiple?: boolean
  limitFiles?: number
}

export const Attachments = (props: Props) => {
  const { multiple = true, limitFiles = 1 } = props
  const { uploadedFiles: files, handleUpload } = useFiles()

  const handleChange = (event: any) => {
    const f: any = Array.from(event.target.files)
    handleUpload(f)
  }

  const allowMoreItems = files.length < limitFiles

  return (
    <Box>
      <div
        style={{
          position: 'sticky',
          top: 0,
          paddingBottom: 8
        }}
      >
        <Button
          variant="contained"
          disabled={!allowMoreItems}
          component="label"
        >
          Anexar
          <input
            hidden
            onChange={handleChange}
            multiple={multiple}
            type="file"
          />
        </Button>
      </div>
      <Box style={{ maxHeight: 200, overflowY: 'auto' }}>
        {files.map((file: any) => (
          <Fragment key={file.id}>
            <Attachment file={file} />
            <Divider />
          </Fragment>
        ))}
      </Box>
    </Box>
  )
}
